<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolFinanceManagementSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/school/finance-management/fee-structure",
                title: "Fee Structure",
                description: "Set up school fees and charges for classes and terms.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/finance-management/bill-payment",
                title: "Bill Payment",
                description: "Record and review payments made against student bills.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/finance-management/reports",
                title: "Financial Reports",
                description: "Analyze recorded income, expenses, and student payment activity.",
                icon: "fa fa-chart-line"
            },
            {
                to: "#",
                title: "Invoice Generation",
                description: "Create invoices and review billed school charges.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Scholarships",
                description: "Manage scholarship awards and student eligibility.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Discounts",
                description: "Configure fee discounts and apply them to student bills.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/finance-management/income",
                title: "Income",
                description: "Record and review income received by the school.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Invoice Generation",
                description: "Create invoices and review billed school charges.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/finance-management/expenses",
                title: "Expenses",
                description: "Track school expenses and review recorded transactions.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Budget",
                description: "Plan school budgets and monitor allocated funds.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "General Ledger",
                description: "Review and manage the school?s financial ledger entries.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Refunds",
                description: "Process and track refunds for eligible school payments.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Bank Reconciliation",
                description: "Match school transactions against bank statements.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Payroll",
                description: "Manage staff payroll details and payment records.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Tax Reports",
                description: "Review tax-related summaries and financial reports.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
